<template>
  <div class="garantie-view">
    <div class="garantie-view__head">
      <div class="garantie-view__head--icon" @click="$router.push('/devis')" v-if="showRetourButton">
        <font-awesome-icon prefix="fas" icon="arrow-circle-left" />
        Retour
      </div>
    </div>
    <div class="garantie-view__head">
      <div class="garantie-view__head--title">
        Devis en ligne
      </div>
    </div>
    <div class="garantie-view__body">
      <div class="garantie-view__body__block">
        <div class="garantie-view__body__block--title">
          Informations sur l'assuré :
        </div>
        <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty && guaranty.client">
          <div class="title">Vos coordonnées :</div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">Nom de l'assuré :</div>
                <div class="field__value">{{ guaranty.client.name_of_signatory }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="field">
                <div class="field__label">RCS n° :</div>
                <div class="field__value">{{ guaranty.client.rcs || '' }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Nom du signataire :</div>
                <div class="field__value">{{ guaranty.client.last_name || '' }} {{ guaranty.client.first_name || '' }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Adresse du signataire :</div>
                <div class="field__value">{{ guaranty.client.address || '' }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Code postal et localité :</div>
                <div class="field__value">{{ guaranty.client.zip || '' }} {{ guaranty.client.city || '' }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Tél du signataire :</div>
                <div class="field__value">{{ guaranty.client.tel || '' }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Adresse mail pour confirmation :</div>
                <div class="field__value">{{ guaranty.client.email || '' }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Date de prise d'effet :</div>
                <div class="field__value">{{ parseEffectiveDate(guaranty) }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Echéance :</div>
                <div class="field__value">{{ parseEndDateShort(guaranty) }}</div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="field">
                <div class="field__label">Nombre de véhicules concernés par l'assistance :</div>
                <div class="field__value">{{ guaranty.nb_vehicles || '' }}</div>
              </div>
            </div>
          </div>
        </div>
        <Preloader v-if="isBusy" />
      </div>
      <div class="garantie-view__body__block mt-3">
        <div class="garantie-view__body__block--title">
          Détail de l'assistance
        </div>

        <div class="garantie-view__body__block--content">
          <div class="description">
            <div class="label mb-2">
              <div class="label--bold rem-18">Garantie assistance</div>
            </div>

            <div class="row">
              <div class="col">
                Dépannage/remorquage avec prise en charge à concurrence de 1200 € TTC<br />
                Franchise 50 km en cas de panne<br />
                <strong>Tarif de base jusqu'à 14 véhicules inclus</strong>&nbsp;&nbsp;{{ pricesList.nb_vehicles_base }}
                €
                TTC/Véhicule/an<br />
                <div class="rem-14">
                  de 5 à 10 véhicules inclus => réduction de 10% sur la totalité du montant de la prime<br />
                  de 11 à 30 véhicules => réduction de 20% sur la totalité du montant de la prime
                </div>
                <strong>TOTAL ANNUEL TTC</strong> (forfait x nombre de véhicules)
                <strong>=</strong>&nbsp;&nbsp;{{ guaranty.nb_vehicles_base ? guaranty.assistance_price : 0 }} €
              </div>
            </div>

            <div class="row" style="padding-top: 20px;">
              <div class="col">
                <div class="label--bold rem-18">Option 1</div>
                Dépannage/remorquage avec prise en charge à concurrence de 2500 € TTC<br />
                <strong>Tarif</strong>&nbsp;&nbsp;{{ pricesList.nb_vehicles_option1 }} € TTC/Véhicule/an<br />
                <strong>TOTAL ANNUEL TTC de l'option 1</strong> (forfait x nombre de véhicules)
                <strong>=</strong>&nbsp;&nbsp;{{ guaranty.nb_vehicles_option1 ? guaranty.assistance_price : 0 }} €
              </div>
            </div>

            <div class="row" style="padding-top: 20px;">
              <div class="col">
                <div class="label--bold rem-18">Option 2</div>
                Dépannage/remorquage avec prise en charge à concurrence de 4000 € TTC<br />
                <strong>Tarif</strong>&nbsp;&nbsp;{{ pricesList.nb_vehicles_option2 }} € TTC/Véhicule/an<br />
                <strong>TOTAL ANNUEL TTC de l'option 2</strong> (forfait x nombre de véhicules)
                <strong>=</strong>&nbsp;&nbsp;{{ guaranty.nb_vehicles_option2 ? guaranty.assistance_price : 0 }} €
              </div>
              <!-- <div class="row" style="padding-top: 20px;">
                <div class="col">
                  Mode de paiement par virement bancaire à Dynassurances
                </div>
              </div> -->
            </div>

            <div class="row" style="padding-top: 20px;">
              <div class="col">
                <div class="label--bold rem-18">Option 3</div>
                Véhicule de remplacement max 3 jours à concurrence de 500€ TTC/jour<br />
                <strong>Tarif</strong>&nbsp;&nbsp;{{ pricesList.nb_vehicles_option3 }} € TTC/Véhicule/an<br />
                <strong>TOTAL ANNUEL TTC de l'option 3</strong> (forfait x nombre de véhicules)
                <strong>=</strong>&nbsp;&nbsp;{{ guaranty.nb_vehicles_option3 ? guaranty.assistance_price : 0 }} €
              </div>
            </div>
          </div>
        </div>

        <div class="print-page-break"></div>

        <div class="garantie-view__body__block--content">
          <div class="description">

            <div class="insurance-info">
              <div class="insurance-info__buttons">
                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                  <div class="insurance-info__buttons--wrapper">
                    <router-link :to="/assistance-autocars/ + $route.params.id" class="blue">
                      Modifier
                    </router-link>
                    <div class="ball-anchor blue"></div>
                  </div>
                </div>
                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                  <div class="insurance-info__buttons--wrapper">
                    <a href="#" @click.prevent="checkMutuaideSubscription(guaranty, getPDF)" class="purple">Voir le
                      devis</a>
                    <div class="ball-anchor purple"></div>
                  </div>
                </div>
                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                  <div class="insurance-info__buttons--wrapper">
                    <router-link :to="/assistance-autocars-souscription/ + $route.params.id" class="purple">
                      Souscrire à l'assistance
                    </router-link>
                    <div class="ball-anchor purple"></div>
                  </div>
                </div>
                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                  <div class="insurance-info__buttons--wrapper">
                    <router-link v-if="!showRetourButton" :to="'/'" class="black">Fermer
                    </router-link>
                    <router-link v-else :to="'/'" class="black">Fermer</router-link>
                    <div class="ball-anchor black"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader'
import insuranceMethods from "@/mixins/insuranceMethods";
// import GrantedGuaranteesList from "@/components/Garantie/DealerInsuranceCampingCar/DealerGuaranteesCampingCar";
import { CLIENT_CIVILITY } from "@/constants/client";

export default {
  name: 'BrokerAssistanceAutocarView',
  components: {
    Preloader,
    // GrantedGuaranteesList
  },
  mixins: [insuranceMethods],
  data() {
    return {
      guaranty: {},
      isBusy: false,
      isBusyResend: false,
      gender_list: [
        'M',
        'Mlle',
        'Mme',
        'Société',
      ],
      family_status_list: [
        'Célibataire',
        'Marié(e)',
      ],
      professions_list: [
        '',
        'Artisant/commerçant',
        'Exploitant agricole',
        'Profession libérale',
        'Chef d\'entreprise',
        'Salarié',
        'Fonctionnaire',
        'VRP',
        'Etudiant',
        'Sans profession',
        'Retraité'
      ],
      guaranty_list: [
        '',
        'Réseau',
        'Maxi Réseau',
        'Maxi Pluss'
      ],
      duration_list: [
        '',
        '6 Mois',
        '12 Mois',
        '24 Mois',
        '36 Mois',
        '48 Mois',
        '18 Mois',
      ],
      assistance_list: [
        'Pack Assistance',
        'Sans pack assistance',
      ],
      showRetourButton: false,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
      isOui: "Oui",
      isNon: "Non",
      pricesList: {
        'nb_vehicles_base': 0,
        'nb_vehicles_option1': 0,
        'nb_vehicles_option2': 0,
        'nb_vehicles_option3': 0,
        'nb_vehicles_option4': 0,
        'nb_vehicles_option5': 0,
      }
    }
  },
  computed: {
    getDownloadLinkConfirmationPdf() {
      if (this.guaranty.id)
        return this.getApiAuthUrl('garantie/confirmation-pdf/' + this.guaranty.id);

      return '';
    },
    showGender() {
      return this.gender_list[this.guaranty.client.civility] ? this.gender_list[this.guaranty.client.civility] : '';
    },
    showFamilyStatus() {
      return this.family_status_list[this.guaranty.client.family] ? this.family_status_list[this.guaranty.client.family] : '';
    },
    showProfession() {
      return this.professions_list[this.guaranty.client.profession] ? this.professions_list[this.guaranty.client.profession] : '';
    },
    // Details
    showGuaranty() {
      return this.guaranty_list[this.guaranty.details.garantie] ? this.guaranty_list[this.guaranty.details.garantie] : '';
    },
    showDuration() {
      if (this.guaranty && this.guaranty.details) {
        return this.duration_list[this.guaranty.details.duration] ? this.duration_list[this.guaranty.details.duration] : '';
      }
    },
    showAssistance() {
      return this.assistance_list[this.guaranty.details.assistance] ? this.assistance_list[this.guaranty.details.assistance] : '';
    },
    getDownloadLink() {
      // alert('getDownloadLink');
      if (this.guaranty.id) {
        // alert('getDownloadLink 288');
        return this.getApiAuthUrl('garantie/generate-assistance-pdf/' + this.guaranty.id);
        // alert('after getDownloadLink 290');
      }

      return '';
    },
    getDownloadLinkCopyPdf() {
      if (this.guaranty.id)
        return this.getApiAuthUrl('garantie/generate-assistance-front-copy-pdf/' + this.guaranty.id);

      return '';
    },
    getPrice() {
      return this.guaranty.price ? this.roundEURWithoutSymbol(this.guaranty.price).replace('.', ',') + ' €' : ''
    },
    getGarantiePrice() {
      return this.guaranty.price && (+this.guaranty.price > 0);
    }
  },
  methods: {
    parseCirculationDate(details) {
      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? day = '0' + day.toString() : '';
      month.length < 2 ? month = '0' + month.toString() : '';

      let date = this.moment(new Date).date(day).month(month).year(year);
      return date.format('DD/MM/YYYY');
    },
    parseSaleDate(quoteDatails) {
      if (quoteDatails.sale_date) {
        return this.moment(quoteDatails.sale_date).format('DD/MM/Y');
      }

      return '';
    },
    parseEffectiveDate(quoteDatails) {
      if (quoteDatails.effective_date) {
        // let day = quoteDatails.datesParse.day_effective,
        //     month = quoteDatails.datesParse.month_effective,
        //     year = quoteDatails.datesParse.year_effective;
        return this.moment(quoteDatails.effective_date).format('DD/MM/Y');
      }

      return '';
    },
    parseEndDate(quoteDatails) {
      if (quoteDatails.effective_date_end) {
        return this.moment(quoteDatails.effective_date_end).add(1, 'days').format('DD/MM/Y');
      }

      return '';
    },
    parseEndDateShort(quoteDatails) {
      if (quoteDatails.effective_date_end) {
        return this.moment(quoteDatails.effective_date_end).add(1, 'days').format('DD/MM');
      }

      return '';
    },
    parseDeliveryDate(quoteDatails) {
      if (quoteDatails.delivery_date) {
        // let day = quoteDatails.datesParse.day_delivery,
        //     month = quoteDatails.datesParse.month_delivery,
        //     year = quoteDatails.datesParse.year_delivery;
        return this.moment(quoteDatails.delivery_date).format('DD/MM/Y');
      }

      return '';
    },
    parseBirthDate(quoteDatails) {
      if (quoteDatails.client.birthday) {
        let day = quoteDatails.client.datesParse.day_birth,
          month = quoteDatails.client.datesParse.month_birth,
          year = quoteDatails.client.datesParse.year_birth;
        return this.moment(quoteDatails.client.birthday).format('DD/MM/Y');
      }

      return '';
    },
    getGuarantyInfo() {
      this.isBusy = true;
      let url = 'garantie/assistance-autocar/' + this.$route.params.id;
      this.apiGet(url).then(response => {
        this.guaranty = response.data.quote ? response.data.quote : {};
        this.numberOfDuplicates = response.data.duplicates;
        this.pricesList = response.data.quote.prices_by_type;
        this.isBusy = false;
      }).catch(error => {
        this.showErrorNotification(error);
        this.$router.push('/');
      })
    },
    printInsurance() {
      window.print();
    },
    resendEmail() {
      this.isBusyResend = true;
      let url = 'garantie/resend-email/' + this.guaranty.id;

      this.apiPost(url, {}).then((response) => {
        this.isBusyResend = false;
        if (response.data.quote && response.data.status == 'success') {
          this.showSuccessNotification(response.data.message, '');
          this.$set(this.guaranty, 'was_sent', response.data.quote.was_sent);
        }
      }).catch(error => {
        this.isBusyResend = false;
        this.showErrorNotification(error);
      })

    },
    getPDF() {
      // alert('getPDF');
      if (this.checkEffectiveDateMutuaide(this.guaranty)) {
        this.refreshTokenForce().then((response) => {
          if (this.getDownloadLink) {
            // alert('getDownloadLink 393');
            let pdfWindow = window.open(this.getDownloadLink);
            if (pdfWindow) this.pdfWindow = pdfWindow;
          } else {
            this.showWarningNotification('Quote Not Found');
          }
        }).catch(error => {
          this.showErrorNotification(error);
        });
      } else {
        this.showWarningNotification('La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d\'effet de la garantie.');
      }
    },
    getConfirmationPDF() {
      this.refreshTokenForce().then((response) => {
        if (this.getDownloadLinkConfirmationPdf) {
          window.location = this.getDownloadLinkConfirmationPdf;
        } else {
          this.showWarningNotification('Quote Not Found');
        }
      }).catch(error => {
        console.log(error)
        this.showErrorNotification(error);
      });
    },
    getFrontPdf() {
      this.refreshTokenForce().then((response) => {
        if (this.getDownloadLinkCopyPdf) {
          window.open(this.getDownloadLinkCopyPdf);
        } else {
          this.showWarningNotification('Quote Not Found');
        }
      }).catch(error => {
        this.showErrorNotification(error);
      });
    }
  },
  mounted() {
    this.getGuarantyInfo();
    this.$eventBus.$emit('sidebar-set-active-tab', 'Garantie Camping Car');

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch('backToDevisDisable');
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit('sidebar-set-active-tab', '');
  },
  watch: {
    pdfWindow: function () {
      window.location.href = '/merci';
    },
    pdfWindowAssistance: function () {
      window.location.href = '/assistance-autocars-view/' + this.guaranty.id;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Garantie/BrokerAssistance/BrokerAssistanceAutocarView.vue